// Signup UI visibility. Backend may still enforce SIGNUP_ALLOWED_EMAILS independently.
// Set REACT_APP_DISABLE_SIGNUP=true in .env.dev to hide the Join tab on hosted dev.
export const signupUiEnabled = process.env.REACT_APP_DISABLE_SIGNUP !== 'true';

// Light friction on /auth: disable forms while devtools appear open (prod only by default).
// Bypassable in seconds — Turnstile/MFA/allowlist remain the real controls.
export const blockDevtoolsOnAuth = process.env.REACT_APP_BLOCK_DEVTOOLS_ON_AUTH === 'true';
